import { createFromIconfontCN } from '@ant-design/icons';

//定义项目中使用的图标
const FontIcon = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_3023001_ro7cpwbi2lg.js',
});

export default FontIcon;